module.exports = __webpack_public_path__ + "img/moodbuster-short-logo.846eeab8.svg";